import isApiError from "@insite/client-framework/Common/isApiError";
import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

export interface PODDataModel {
    pod: PODData[];
    error: boolean;
    parameter: PODParameter;
}

export interface PODData {
    OrderNumber: string;
    OrderDate: string;
    DeliveryId: string;
    DriverName: string;
    DeliveryDate: string;
    GroupId: string;
    GroupName: string;
    LocationAddress: string;
    LocationCity: string;
    LocationKey: string;
    LocationPostalCode: string;
    LocationState: string;
    Name: string;
    DeliveryNotes: string;
    ReceivedBy: string;
    SignatureReceived: boolean;
    PODDataReceived: boolean;
    PreviousPodId: string;
    NextPodId: string;
    PODItems: PODItemResponse[];
    PODImages: PODImageResponse[];
}

export interface PODItemResponse {
    PODId: string;
    SKU: string;
    Description: string;
    Quantity: number;
}

export interface PODImageResponse {
    PODId: string;
    ImageType: string;
    Url: string;
}

export interface PODDataResultModel {}

export interface PODParameter extends ApiParameter {
    id?: string;
    orderNumber?: string;
    isWillCallPod?: boolean;
    // onError?: (error: string, statusCode?: number) => void;
}

const PODUrl = "api/v1/pod/podDetails";

export async function getPODData(
    parameter: PODParameter & HasOnSuccess<PODDataResultModel> & HasOnComplete<PODDataResultModel>,
) {
   const response = await get<PODDataModel>(
        `${PODUrl}?orderNumber=${parameter.orderNumber}&podId=${parameter.id || ""}&isWillCallPod=${parameter.isWillCallPod}`
    );
    return response;
}

export interface SendPodEmailParameter {
    orderNumber: string;
    isWillCallPod: boolean;
    emailTo: string;
    emailFrom: string;
    subject: string;
    message: string;
}

// Match C# OperationResult return shape
export interface SendPodEmailResult {
    isSuccess: boolean;
    message: string;
    data?: any;
}

const url = "api/v1/pod/sendPodEmail";

export async function sendPodEmailService(model: SendPodEmailParameter) {
    try {
        const result = await post<SendPodEmailParameter, SendPodEmailResult>(url, model);

        return {
            successful: result.isSuccess,
            message: result.message,
            data: result.data,
        };
    } catch (error: any) {
        if (isApiError(error)) {
            return {
                successful: false,
                message: error.errorJson?.message || "Failed to send POD email.",
            };
        }

        throw error; 
    }
}

export interface PdfResultModel {
    successful: boolean;
    result: false | Blob;
    errorMessage?: undefined;
    statusCode?: undefined;
}

const podUrl = "api/v1/pod/getPODPdf";

export async function getPODPdf(orderNumber: string, isWillCall: boolean){
      try {
        const response = await fetch(`${podUrl}/${orderNumber}?isWillCall=${isWillCall}`);
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return {
            successful: true,
            result: blob,
        };
       
    } catch (error: any) {
       if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorMessage || error.errorJson.message || "Something went wrong!",
                statusCode: error.status,
            };
        }
        if (error.errorMessage) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: error.status,
            };
        }
        throw error; 
    }
}
